import type { ApolloClientConfig } from '../types';

import { withAccessToken, withAuthMiddleware, withHeaders, withHttpLink, withSGHeader } from '@/graphql/utils/links';
import { withSentryTracing } from '@/libraries/sentry/graphql';

export async function getServerLinks({ headers, pinia }: ApolloClientConfig) {
	const serverLinks = [
		withSGHeader(pinia),
		withAccessToken(pinia),
		withAuthMiddleware(pinia),
		withHeaders(headers) /* , withRetry() */,
		withSentryTracing(),
	];

	serverLinks.push(withHttpLink());

	return serverLinks;
}

export async function getClientLinks({ headers, pinia }: ApolloClientConfig) {
	const clientLinks = [withSGHeader(pinia), withAccessToken(pinia), withAuthMiddleware(pinia), withHttpLink()];

	if (headers) {
		clientLinks.unshift(withHeaders(headers));
	}

	return clientLinks;
}
